<template>
  <div class="page order-center-page ">
    <div class="page-content">
      <div class="header">
        <el-form :inline="true">
          <el-form-item label="" prop="appType">
            <el-select v-model="appType" size="small" style="width: 100px" placeholder="应用类型" filterable clearable
              :loading="appTypeLoading" autocomplete="off" @change="initData">
              <el-option v-for="item in appTypeData" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="" prop="countryId">
            <el-select v-model="countryId" size="small" style="width: 100px" placeholder="国家" filterable clearable
              :loading="countryLoading" autocomplete="off" @change="initData">
              <el-option v-for="item in countryData" :key="item.id" :label="item.zhName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="" prop="appId">
            <el-select v-model="appId" size="small" placeholder="应用名称" filterable clearable :loading="appLoading"
              autocomplete="off" @change="initData" style="max-width: 150px;">
              <el-option :label="item.name" :value="item.id" v-for="(item, index) in appList" :key="index">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.typeName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <SelectDatePage @setDate="setDate" :startDateListD="startDateList" @initData="initData"></SelectDatePage>
        <!-- 刷新按钮 -->
        <div style="display: flex;align-items: center;justify-content: center;margin-left: 10px;">
          <el-button icon="el-icon-refresh" size="small" @click="initData">刷新</el-button>
          <div
            style="display: flex;flex-direction: column;align-items: center;justify-content: center;margin-left: 10px;">
            <el-checkbox v-model="isShow" @change="handleChange">自动更新</el-checkbox>
            <div style="color: #999;font-size: 12px;">{{ timmerNumber + '秒后刷新' }}</div>
          </div>
        </div>
      </div>
      <div class="contenter">
        <div class="carder" v-loading="maindataLoading">
          <DataCardPage :dataCore="maindataList"></DataCardPage>
        </div>
        <div class="dataer">
          <div class="data-title">数据趋势</div>
          <div class="data-box">
            <div class="data-item" v-loading="datatendsLoading" v-for="(item, index) in maindataList" :key="index">
              <div :id="'echart_' + item.key.charAt(0).toLowerCase() + item.key.slice(1)"></div>
            </div>
          </div>
          <!-- <div class="data-box">
            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_saleAmount"></div>
            </div>
            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_visaCount"></div>
            </div>
            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_refundAmount"></div>
            </div>
            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_orderCount"></div>
            </div>
            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_viewCount"></div>
            </div>
            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_userCount"></div>
            </div>
            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_entryCardAmount"></div>
            </div>
            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_visadAmount"></div>
            </div>
            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_merchantAmount"></div>
            </div>
            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_weComAmount"></div>
            </div>
            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_pEntryCardAmount"></div>
            </div>
            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_agentSaleAmount"></div>
            </div>

            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_taobaoAmount"></div>
            </div>
            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_redBookAmount"></div>
            </div>
            <div class="data-item" v-loading="datatendsLoading">
              <div id="echart_tiktokAmount"></div>
            </div>
          </div> -->
        </div>
        <div class="dataer">
          <div class="data-title">产品销售排名Top10</div>
          <div class="data-box">
            <div class="data-row" v-loading="productLoading">
              <div id="echart_product"></div>
            </div>
          </div>
        </div>
        <div class="dataer">
          <div class="data-title">产品办签人数排名</div>
          <div class="data-box">
            <div class="data-row" v-loading="visacountrankLoading">
              <div id="echart_visacountrank"></div>
            </div>
          </div>
        </div>
        <div class="dataer">
          <div class="data-title">小程序内部关键词搜索</div>
          <div class="data-box">
            <div class="data-row" v-loading="keywordLoading">
              <div id="echart_keyword" style="width: 100%;height:400px;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://cdn.jsdelivr.net/npm/echarts@5.4.0/dist/echarts.min.js"></script>
<script>

import SelectDatePage from './components/selectDate/selectDate.vue'
import DataCardPage from './components/dataCard/dataCard.vue'
import * as echarts from 'echarts'
import 'echarts-wordcloud'

import {
  maindata,
  datatends,
  productrank,
  visacountrank,
  keywordrank
} from "@/api/report.js";
import { appinfoquery, apptypeselect, } from "@/api/settings.js"
import { countrylist } from "@/api/personal.js";

export default {
  components: { SelectDatePage, DataCardPage },
  data() {
    return {
      datatendsLoading: true,
      maindataLoading: true,
      dataLoading: false,
      productLoading: true,
      visacountrankLoading: true,
      keywordLoading: true,
      keywordList: [],
      productList: [],
      visacountrankList: [],
      maindataList: [],
      startDateList: [], // 时间范围 => 子组件dataDate 返回;
      dateType: 1, //  时间类型
      appId: '',
      appLoading: true,
      appList: '',
      countryId: '',
      countryLoading: true,
      countryData: [],
      appTypeLoading: false,
      appType: '',
      appTypeData: [],
      timmerNumber: 60,
      timmer: null,
      isShow: true,
      timmerFn: false,//定时器要的刷新方法
      timmerFnData:{}
    }
  },
  mounted() {
    this.initDate()
    this.getDatatends()
    this.createTimmer()
  },
  methods: {
    handleChange(e) {
      console.log(e,this.isShow)
      if (!this.isShow) {
        clearInterval(this.timmer)
        this.timmer = null
      }else{
        this.createTimmer()
      }
    },
    createTimmer() { 
      this.timmer = setInterval(() => {
        if (this.timmerNumber > 0) {
          this.timmerNumber--
        } else {
          if(!this.timmerFn){
            this.initData()
          }else{
            this.setDate(this.timmerFnData.date1,this.timmerFnData.date2)
          }
          this.timmerNumber = 60
        }
      }, 1000)
    },
    resetTimmer() {
      clearInterval(this.timmer)
      this.timmer = null

      this.timmerNumber = 60
      this.createTimmer()
    },
    // 应用列表
    async getappList() {
      this.appLoading = true
      await appinfoquery({ 'page.index': 1, 'page.size': 1000 }).then(res => {
        this.appList = res.data.rows
        this.appList.unshift({ name: '全部', id: '' })
        this.appLoading = false
      })
      this.countryLoading = true
      countrylist({}).then((res) => {
        this.countryData = res.data;
        this.countryLoading = false;
      });
      this.appTypeLoading = true
      apptypeselect().then((res) => {
        this.appTypeData = res.data;
        this.appTypeLoading = false
      });
    },
    initData() {
      this.getMaindata()
      this.getDatatends()

      this.getProductrankFn()
      this.getVisacountrankFn()
      this.getKeywordrankFn()
      this.timmerNumber = 60

    },
    //  初始化时间 一周
    initDate() {
      // 默认今天$moment(ruleForm.customer_BirthDay).format("YYYY-MM-DD")
      this.$set(this.startDateList, 0, this.$moment(new Date()).format("YYYY-MM-DD"))
      this.$set(this.startDateList, 1, this.$moment(new Date()).format("YYYY-MM-DD"))
      this.getMaindata()
      this.getappList()
      this.getProductrankFn()
      this.getVisacountrankFn()
      this.getKeywordrankFn()
      this.timmerFn = false//定时器要的刷新方法
      this.timmerFnData = {}
      this.timmerNumber = 60
    },

    // 请求核心数据数据
    getMaindata() {
      this.maindataLoading = true
      let data = {
        startDate: this.startDateList[0],
        endDate: this.startDateList[1],
        type: this.dateType,
        appId: this.appId,
        countryId: this.countryId,
        appType: this.appType
      }
      // 报表类型 0全部 1指定app的报表 2指定国家的报表
      if (this.countryId || this.appId) {
        data.reportType = this.countryId > 0 && this.appId > 0 ? 0 : this.countryId > 0 && !this.appId ? 2 : 1
      }

      maindata(data)
        .then(res => {
          this.maindataList = res.data
          this.maindataLoading = false
        })
        .catch(() => {
          this.maindataLoading = false
        })
    },

    //  请求数据趋势
    getDatatends() {
      this.datatendsLoading = true
      let data = {
        startDate: this.startDateList[0],
        endDate: this.startDateList[1],
        type: this.dateType,
        appId: this.appId,
        countryId: this.countryId,
        datatendsType: 1001,
        appType: this.appType
      }
      // 报表类型 0全部 1指定app的报表 2指定国家的报表
      if (this.countryId || this.appId) {
        data.reportType = this.countryId > 0 && this.appId > 0 ? 0 : this.countryId > 0 && !this.appId ? 2 : 1
      }

      datatends(data)
        .then(res => {
          this.trendData = res.data

          this.handleEChartData()
          // 等待一秒EChart渲染
          setTimeout(() => {
            this.datatendsLoading = false
          }, 1000)
        })
        .catch(() => {
          this.datatendsLoading = false
        })
    },
    getProductrankFn() {
      this.productLoading = true
      let data = {
        startDate: this.startDateList[0],
        endDate: this.startDateList[1],
        type: this.dateType,
        appId: this.appId,
        countryId: this.countryId,
        appType: this.appType
      }
      // 报表类型 0全部 1指定app的报表 2指定国家的报表
      if (this.countryId || this.appId) {
        data.reportType = this.countryId > 0 && this.appId > 0 ? 0 : this.countryId > 0 && !this.appId ? 2 : 1
      }

      productrank(data).then(res => {
        this.productList = res.data
        // 获取X轴显示日期
        let xDatas = this.productList.map(res => res.visaName);
        let yDatas = this.productList.map(res => res.amount);
        let echartSeries = [{ data: yDatas, type: 'bar', label: { show: true, position: 'inside' } }]

        this.getEChartsFn('产品销售排名', xDatas, echartSeries, 'echart_product')

        setTimeout(() => {
          this.productLoading = false
        }, 1000)
      })
        .catch(() => {
          this.productLoading = false
        })
    },
    getVisacountrankFn() {
      this.visacountrankLoading = true
      let data = {
        startDate: this.startDateList[0],
        endDate: this.startDateList[1],
        type: this.dateType,
        appId: this.appId,
        countryId: this.countryId,
        appType: this.appType
      }
      // 报表类型 0全部 1指定app的报表 2指定国家的报表
      if (this.countryId || this.appId) {
        data.reportType = this.countryId > 0 && this.appId > 0 ? 0 : this.countryId > 0 && !this.appId ? 2 : 1
      }

      visacountrank(data).then(res => {
        this.visacountrankList = res.data
        // 获取X轴显示日期
        let xDatas = this.visacountrankList.map(res => res.visaName);
        let yDatas = this.visacountrankList.map(res => res.count);
        let echartSeries = [{ data: yDatas, type: 'bar', label: { show: true, position: 'inside' } }]

        this.getEChartsFn('办签人数排名', xDatas, echartSeries, 'echart_visacountrank')

        setTimeout(() => {
          this.visacountrankLoading = false
        }, 1000)
      })
        .catch(() => {
          this.visacountrankLoading = false
        })
    },
    getKeywordrankFn() {
      this.keywordLoading = true
      let data = {
        startDate: this.startDateList[0],
        endDate: this.startDateList[1],
        type: this.dateType,
        appId: this.appId,
        // 报表类型 0全部 1指定app的报表 2指定国家的报表
        reportType: this.appId > 0 ? 1 : 0
      }
      keywordrank(data).then(res => {
        this.keywordList = res.data
        this.wordCloudChartFn()
        setTimeout(() => {
          this.keywordLoading = false
        }, 1000)
      })
        .catch(() => {
          this.keywordLoading = false
        })
    },
    wordCloudChartFn() {

      // 获取X轴显示日期 
      let yDatas = this.keywordList.map(item => { return { value: item.count, name: item.keyword } });

      const options = {
        series: [
          {
            type: 'wordCloud',
            //数据中的值将映射到的文本大小范围。默认大小为最小12px，最大60px。
            sizeRange: [12, 46],
            //文本旋转范围和步进度。
            rotationRange: [0, 0],
            //以像素为单位的网格大小，用于标记画布的可用性
            //网格尺寸越大，单词之间的间距越大。
            gridSize: 0,
            layoutAnimation: true,//渲染动画
            shape: 'circle',  // 圆形布局
            width: '90%',  // 占容器宽度的90%
            height: '90%',
            textStyle: {
              normal: {
                color: function () {
                  return 'rgb(' + [
                    Math.round(Math.random() * 160),
                    Math.round(Math.random() * 160),
                    Math.round(Math.random() * 160)
                  ].join(',') + ')';
                }
              }
            },
            emphasis: { //高亮的效果
              textStyle: {
                fontWeight: 'bold',
                color: '#ffffff'
              }
            },
            //数据是一个数组。每个数组项必须具有名称和值属性。
            data: yDatas
          }
        ]
      }
      const myChart = echarts.init(document.getElementById('echart_keyword'), null, { height: '400px' })
      // 3.通过实例.setOptions(option)
      myChart.setOption(options);

    },
    //  子组件返回时间
    setDate(date1, date2) {
      // this.startDateList = date1;
      this.startDateList[0] = date1[0]
      this.startDateList[1] = date1[1]
      this.timmerFn =  true //定时器要的刷新方法
      this.timmerFnData = {
        date1,date2
      }
      this.dateType = date2
      //  传时间
      this.getMaindata() //  核心数据
      this.getDatatends() //  数据趋势
      this.getProductrankFn()
      this.getVisacountrankFn()
      this.getKeywordrankFn()
      this.timmerNumber = 60
    },

    handleEChartData() {
      let infoData = {};  
      this.maindataList.forEach(item => { 
        const { key, title } = item;
 
        const lowerKey = key.charAt(0).toLowerCase() + key.slice(1);
 
        infoData[lowerKey] = [];
        infoData[`${lowerKey}_Title`] = title;
      });

      // 分装数据 
      for (const key in this.trendData) {
        // 获取X轴显示日期 
        let xDatas = this.trendData[key].map(item => item.dates)
        let trendData = this.trendData[key].map(item => {
          item.value = item.count
          return { ...item }
        })
        let echartSeries = [{ data: trendData, type: 'line' }]
        this.getEChartsFn(infoData[key + '_Title'], xDatas, echartSeries, 'echart_' + key)
      }
    },
    handleEChartData1() {
      let infoData = {
        saleAmount_Title: '营业额',
        saleAmount: [], // 营业额
        visaCount_Title: '出签人数',
        visaCount: [], // 出签人数
        refundAmount_Title: '退款金额',
        refundAmount: [], // 退款金额
        orderCount_Title: '订单数量',
        orderCount: [], // 订单数量
        viewCount_Title: '浏览量',
        viewCount: [], // 浏览量
        userCount_Title: '新增访问用户数',
        userCount: [], // 新增访问用户数 
        entryCardAmount_Title: '入境卡金额',
        entryCardAmount: [],
        visadAmount_Title: '签证金额',
        visadAmount: [],
        merchantAmount_Title: '商户金额',
        merchantAmount: [],
        weComAmount_Title: '企业微信收银',
        weComAmount: [],
        pEntryCardAmount_Title: '平台入境卡金额',
        pEntryCardAmount: [],
        agentSaleAmount_Title: '分销营收',
        agentSaleAmount: [],
        taobaoAmount_Title: '淘宝收银',
        taobaoAmount: [],
        redBookAmount_Title: '小红书收银',
        redBookAmount: [],
        tiktokAmount_Title: '抖音收银',
        tiktokAmount: [],

      }

      // 分装数据 
      for (const key in this.trendData) {
        // 获取X轴显示日期 
        let xDatas = this.trendData[key].map(item => item.dates)
        let trendData = this.trendData[key].map(item => {
          item.value = item.count
          return { ...item }
        })
        let echartSeries = [{ data: trendData, type: 'line' }]
        this.getEChartsFn(infoData[key + '_Title'], xDatas, echartSeries, 'echart_' + key)
      }
    },
    getEChartsFn(title, xDatas, series, echartId) {
      const myChart = echarts.init(document.getElementById(echartId), null, { height: '320px' })
      // 绘制图表
      const option = {
        title: {
          text: title,
          left: '1%'
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: xDatas,
          axisTick: {
            alignWithLabel: true // 刻度与标签对齐
          },
          axisLabel: {
            interval: 0,
            rotate: title == '产品销售排名' ? 0 : "25",
            formatter: function (params) {
              params = params.replace(/-/g, '/').replace(/（/g, '').replace(/）/g, '')
              var newParamsName = "";// 最终拼接成的字符串
              var paramsNameNumber = params.length;// 实际标签的个数
              var provideNumber = 8;// 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
              /**
               * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
               */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";// 表示每一次截取的字符串
                  var start = p * provideNumber;// 开始截取的位置
                  var end = start + provideNumber;// 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;// 最终拼成的字符串
                }

              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              //将最终的字符串返回
              return newParamsName
            }

          }
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: series,
        tooltip: {
          trigger: 'axis',
          show: true
        },
        toolbox: {
          right: 10,
          feature: {
            dataView: {
              title: '查看数据',
              show: true,
              readOnly: false
            },
            saveAsImage: {
              title: '下载图片',
              pixelRatio: 2, // 图片清晰度，值越大越清晰
              name: title + '数据报表' // 保存的图片文件名
            }
          }
        }
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
    },

  },
  beforeDestroy() {
    // 清除定时器
    if (this.timmer) { // 存在定时器
      clearInterval(this.timmer)
      this.timmer = null
    }
    console.log(this.timmer)
  }
}
</script>

<style scoped lang="scss">
.order-center-page {
  width: 100%;
  height: 100%;
}

@media (min-width: 1280px) {
  .page-content {
    width: 80vw !important;
    max-width: 100%;
  }
}

@media (max-width: 1280px) {
  .page-content {
    width: 1000px !important;
    max-width: 100%;
  }
}

.page-content {
  position: relative;
  width: 1000px;
  margin: 0 auto;
  margin-top: 20px;
  height: 100%;

  // display: flex;
  //   overflow-y: auto;
  //   height: calc(100% - 120px);
  //   padding: 10px;
  //   position: relative;
  // background-color: #ffffff;
  .header {
    box-sizing: border-box;
    width: 100%;
    min-width: calc(100% - 20px);
    padding: 10px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 7px 25px 0 #e6edff;
    display: inline-flex;

    .el-form-item {
      margin-bottom: 0 !important;
    }
  }

  .contenter {
    width: 100%;
    min-width: calc(100% - 20px);

    .carder {
      .date-wrap {
        box-sizing: border-box;
        width: 100%;
        padding: 10px;
        margin: 10px 0;
        border-radius: 5px;
        box-shadow: 0 7px 25px 0 #e6edff;
        display: inline-flex;
        background-color: #ffffff;
      }
    }

    .dataer {
      .data-title {
        box-sizing: border-box;
        width: 100%;
        height: 50px;
        padding-left: 15px;
        font-weight: bold;
        font-size: 16px;
        line-height: 50px;
        display: flex;
        border-radius: 5px 0 0 5px;
        align-items: center;
        background-color: #ffffff;
        border-bottom: 1px solid #e9e9e9;

        .data-name {
          margin-left: 8px;
        }
      }

      .data-box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: left;

        .data-item {
          background-color: #ffffff;
          width: 30%;
          height: 300px;
          padding: 10px;
          border-radius: 5px;
          box-shadow: 0 7px 25px 0 #e6edff;
          margin-bottom: 10px;
          margin-right: 10px;
          box-sizing: border-box;
        }

        .data-row {
          background-color: #ffffff;
          width: 100%;
          min-height: 300px;
          padding: 10px;
          border-radius: 5px;
          box-shadow: 0 7px 25px 0 #e6edff;
          margin-bottom: 10px;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
